module.exports = __webpack_public_path__ + "static/word-disinfect.1ce212d2.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-disinfect.png
// module id = 990
// module chunks = 2